// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const AuthModalRecord = require('client-v2/common/containers/auth-modal/record')
const ConfirmModalRecord = require('client-v2/common/containers/confirm-modal/record')
const { FeedStreamRecord } = require('client-v2/common/containers/feed/records')
const {
  PageContextOverlayRecord: { reviver: pageContextReviver }
} = require('client-v2/common/models/page-context/records')
const ProfileUserRecord = require('client-v2/user-profile/containers/profile-user/record')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const UserRecord = require('client-v2/common/state/user/record')
const {
  defaultReviver,
  listReviver,
  keyedReviver
 } = require('client-v2/common/state/revivers')
// Entry imports
const LinkModalRecord = require('client-v2/into-landing/containers/link-modal/record')
const SMSModalRecord = require('client-v2/into-landing/containers/sms-modal/record')

 class IntoLikerRecord extends Immutable.Record({
  'user_id': Number(),
  'display_name': String(),
  'photo_url': String(),
  username: String()
}) {
  // No methods
}

IntoLikerRecord.reviver = keyedReviver(IntoLikerRecord, {
  // No nested data structures
})

class IntoMetaRecord extends Immutable.Record({
  media: new Immutable.List(), // List of strings
  provider: new Immutable.Map()
}) {
  // No methods
}

IntoMetaRecord.reviver = keyedReviver(IntoMetaRecord, {
  media: defaultReviver,
  provider: defaultReviver
})

class IntoLandingTopicRelatedRecord extends Immutable.Record({
  type: String(),
  name: String(),
  slug: String(),
  meta: null,
  thumbnailUrl: String()
}) {
  // No methods
}

IntoLandingTopicRelatedRecord.reviver = keyedReviver(IntoLandingTopicRelatedRecord, {})

class IntoLandingArticleRecord extends Immutable.Record({
  count: Number(),
  description: String(),
  embedUrl: String(),
  hash: String(),
  hostname: String(),
  image: String(),
  likers: Immutable.List(),
  md5image: String(),
  'mixes_count': Number(),
  'mixers_count': Number(),
  meta: null,
  referredBy: Immutable.Map(),
  isShareReferral: Boolean(),
  related: Immutable.List(),
  thumbnail: String(),
  title: String(),
  type: String(),
  url: String(),
  'url_id': String(),
  'url_hash': String()
}) {
  // No methods
}

// Record Revivers
IntoLandingArticleRecord.likersReviver = listReviver(IntoLikerRecord.reviver)
IntoLandingArticleRecord.relatedReviver = listReviver(IntoLandingTopicRelatedRecord.reviver)
IntoLandingArticleRecord.metaReviver = IntoMetaRecord.reviver
IntoLandingArticleRecord.referredByReviver = IntoLikerRecord.reviver
IntoLandingArticleRecord.reviver = keyedReviver(IntoLandingArticleRecord, {
  likers: IntoLandingArticleRecord.likersReviver,
  meta: IntoLandingArticleRecord.metaReviver,
  referredBy: IntoLandingArticleRecord.referredByReviver,
  related: IntoLandingArticleRecord.relatedReviver
})

class IntoLandingTopicRecord extends Immutable.Record({
  type: String(),
  name: String(),
  slug: String(),
  meta: null,
  thumbnailUrl: String(),
  followerCount: Number(),
  followers: Immutable.List(),
  related: Immutable.List()
}) {
  // No methods
}

// Record Revivers
IntoLandingTopicRecord.relatedReviver = listReviver(IntoLandingTopicRelatedRecord.reviver)
IntoLandingTopicRecord.followersReviver = listReviver(IntoLikerRecord.reviver)
IntoLandingTopicRecord.reviver = keyedReviver(IntoLandingTopicRecord, {
  followers: IntoLandingTopicRecord.followersReviver,
  related: IntoLandingTopicRecord.relatedReviver
})

class IntoLandingFeedItemRecord extends Immutable.Record({
  article: null
}){
  // No methods
}

IntoLandingFeedItemRecord.reviver = keyedReviver(IntoLandingFeedItemRecord, {
  article: IntoLandingArticleRecord.reviver
})

class IntoLandingRootRecord extends Immutable.Record({
  // Common state
  env: null,
  router: null,
  user: null,
  // Common containers
  authModal: null,
  confirmModal: null,
  // Entry containers
  articleProfile: null,
  feed: null,
  linkModal: null,
  pageContext: null,
  posterUrl: String(),
  profileUser: null,
  smsModal: null,
  topicProfile: null,
  videoUrl: String()
}) {
  // No methods
}

IntoLandingRootRecord.reviver = keyedReviver(IntoLandingRootRecord, {
  // Common state
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: UserRecord.reviver,
  // Common containers
  authModal: AuthModalRecord.reviver,
  confirmModal: ConfirmModalRecord.reviver,
  // Entry containers
  articleProfile: IntoLandingArticleRecord.reviver,
  feed: FeedStreamRecord.reviver,
  linkModal: LinkModalRecord.reviver,
  pageContext: pageContextReviver,
  posterUrl: defaultReviver,
  profileUser: ProfileUserRecord.reviver,
  smsModal: SMSModalRecord.reviver,
  topicProfile: IntoLandingTopicRecord.reviver,
  videoUrl: defaultReviver
})

module.exports = IntoLandingRootRecord
